import kitchenInstance from '../instance'

const updateWaiterNotification = (id, data) => {
	return kitchenInstance.put(`/waiterNotifications/${id}/status`, data)
}

export default updateWaiterNotification
